import { z } from 'zod';
import { MESSAGE_STATUSES } from './status.js';

/**
 * Live inbox notifications (PLAN.md §8). The database broadcasts them on private Realtime topics; they
 * carry ids and a status only, never message text. The browser refetches through RLS when one arrives.
 */

/** Broadcast event name used by app.inbox_broadcast. */
export const INBOX_EVENT = 'inbox';

export const InboxEventSchema = z.discriminatedUnion('t', [
  z.object({
    t: z.literal('msg'),
    merchant_id: z.uuid(),
    message_id: z.uuid(),
    status: z.enum(MESSAGE_STATUSES),
    direction: z.enum(['in', 'out']),
  }),
  z.object({ t: z.literal('merchant'), merchant_id: z.uuid() }),
  // M6: the bell. Sent only on the recipient's own topic.
  z.object({ t: z.literal('notif'), notification_id: z.uuid() }),
]);
export type InboxEvent = z.infer<typeof InboxEventSchema>;

/** The topics a member listens to: their own, plus the workspace's admins topic for admins. */
export function inboxTopics(workspaceId: string, userId: string, isAdmin: boolean): string[] {
  const own = `ws:${workspaceId}:u:${userId}`;
  return isAdmin ? [own, `ws:${workspaceId}:admins`] : [own];
}
